import React, { useEffect, useState, useRef } from "react"
import { Button, Container } from "./auvelity-ui"
import tw from "twin.macro"
import { handleNavClick } from "../utils" 
import speaker from "../images/icons/speaker.png"

const CallingAllAdvocates = () => {
  return (
    <section className="calling-advocates">
      <Container>
        <div className="advocate-container">
          <div
            css={[
              tw`flex flex-col w-full items-center text-center lg:pt-16 pb-6 lg:(h-full text-left py-0 flex-row justify-between transition invisible opacity-0 transform translate-y-10 duration-200)`,
              tw`lg:(visible opacity-100 translate-y-0 duration-500)`,
            ]}
          >
            <div
              className="content-container"
              css={[
                tw`w-full min-h-full flex flex-col justify-start items-center relative py-1 lg:(w-2/5 justify-center items-start px-1)`,
              ]}
            >
              <img src={speaker} className="speaker-icon" alt="" />
            </div>
            <div
              className="advocate-paragraph"
              css={[
                tw`relative px-4 lg:(mr-0 px-0)`,
                tw`lg:order-1`,
              ]}
            >
              <div
                css={[
                  tw`text-2xl text-center text-yellow font-bold leading-tight mb-1 lg:(mt-0 text-4xl mb-4 text-left)`,
                  tw`text-blue`,
                ]}
              >
                Calling all AUVELITY advocates!
              </div>
              <p
                css={[
                  tw`mb-4 font-semibold px-2 text-[14px] md:text-lg text-lightblack lg:(text-left px-0 max-width[700px]) xl:(mb-8)`,
                ]}
              >
                Have an AUVELITY story to share? We&rsquo;ve been looking for you. Reach out to us to become an AUVELITY Ambassador today! 
              </p>
              
              <Button
                arrow={true}
                variant={"yellow"}
                env="white"
                onClick={e => handleNavClick(e, "/calling-all-advocates")}
              >
                Become an Ambassador
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default CallingAllAdvocates
